export default {
  Title: 'Tham số báo cáo',
  Year: 'Năm',
  ViewReport: 'Xem báo cáo',
};
